// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__PScLZ","noInteraction":"EventWrapper_noInteraction__3WAhw"};